import React, { useState, useEffect } from 'react';
import {
  message,
  Divider,
  Button,
  Checkbox,
  Menu, Select, Dropdown,
  Space, Modal,
  Statistic,
  Affix,
  Switch
} from 'antd';
import {
  CloseOutlined,
  PlusOutlined,
  ReloadOutlined,
  DownloadOutlined,
  DeleteOutlined,
  IssuesCloseOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { toThousands, toFixed2 } from '../../utils/Numeric';
import { chkPallet } from '../../utils/Pallet';

import {
  getOrderPackageList,
  getOrderPackagePalletList,
  getSupplierByOrderid,
  insertOrderPackageFillType,
  updatePalletReviceStatus,
  updateCartonReviceStatus,
  insertSelfPackagePallet,
  insertSelfPackage,
  deleteSelfPackagePallet,
  deleteSelfPackage,
  getOrderPackageProgress,
  insertPackageNo,
  deletePackageNo,
  getPackageNoList,
  returnOrderPackageNo,
  updateOrderDeliveriedStatus,
  updateOrderPackageCartonState
} from '../../services/Order';
import { Page } from '../../components';
import carton, { default as CartonNew } from './carton';
import { default as PackageDetail } from './packageDetail';
import { default as SyncList } from './syncList';

import './style/index'
const { Countdown } = Statistic;
export default React.forwardRef((props, ref) => {
  const {
    suppliers,
    order,
    tabStatus,
    setTabStatus,
    onSyncOrderPackages,
    onReturnOrderPackages,
    onCloseCallback,
    downloadPackage,
    downloadPackagePost,
    downloadPalletDetail
  } = props;
  const [isReadonly, setReadonly] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [orderSuppliers, setOrderSuppliers] = useState([]);
  const [packageNos, setPackageNos] = useState([]);
  const [selectedSupplierId, setSelectedSupplierId] = useState(-1);
  const [selectedPackageId, setSelectedPackageId] = useState(-1);
  const [pallets, setPallets] = useState([]);
  const [packages, setPackages] = useState([]);
  const [progress, setProcess] = useState([]);
  const [isShowSync, setShowSync] = useState(false);
  const [isShowSupplier, setShowSupplier] = useState(true);
  const [isShowProgress, setShowProgress] = useState(false);
  const [isShowCartonNew, setShowCartonNew] = useState(false);
  const [currentPalletId, setCurrentPalletId] = useState(undefined);
  const [isShowDeliveryDate, setShowDeliveryDate] = useState(false);
  const [container, setContainer] = useState(null);
  const filteredPallets = pallets
    .filter(x => x.supplier_id === selectedSupplierId || selectedSupplierId === -1)
    .filter(y => y.package_id === selectedPackageId || selectedPackageId === -1);
  filteredPallets.reverse();
  const filteredPackages = packages
    .filter(x => x.supplier_id === selectedSupplierId || selectedSupplierId === -1)
    .filter(y => y.package_id === selectedPackageId || selectedPackageId === -1);

  const [progressInfo, setProgressInfo] = useState({ percent: 0, orderGoodsCount: 0, orderGoodsOkCount: 0 });

  const selectedPackageNo = packageNos.find(x => x.id === selectedPackageId);
  const reloadPackageNoList = (callback) => {
    getPackageNoList(order.id, selectedSupplierId).then(data => {
      setPackageNos(data)
      callback && callback(data);
    });
  }

  const updatePackageNoListDeleteFlag = (carton, delete_flag) => {
    const temp = packages.map(x => {
      if (x.id === carton.id) {
        return { ...x, delete_flag: delete_flag }
      } else {
        return x;
      }
    })
    setPackages(temp);
  }

  useEffect(() => {
    setLoading(true);
    reload(() => (setLoading(false)));
    const temp = document.getElementsByClassName("ant-tabs-tabpane ant-tabs-tabpane-active")[0];
    if (temp) setContainer(temp);
  }, []);

  useEffect(() => {
    if (selectedSupplierId) {
      reloadPackageNoList();
    }
  }, [selectedSupplierId]);

  const onChangeSupplier = (id) => {
    setSelectedSupplierId(id);
    setSelectedPackageId(-1);
  }

  const onAddNewPackage = (values, callback) => {
    try {
      const key = 'new_pallet';
      console.log('onNewPallet:', values);
      message.loading({ content: '正在添加散箱...', key });
      insertSelfPackage(order.id, values).then(() => {
        updateOrderDeliveriedStatus(order.id, selectedSupplierId).then(data => {

        })
        reload();
        message.success({ content: `添加散箱成功`, key, duration: 2 });
        callback && callback();
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDeleteCarton = (carton_id) => {
    try {
      const key = 'new_pallet';
      console.log('onNewPallet:', carton_id);
      message.loading({ content: '正在删除散箱...', key });
      deleteSelfPackage(order.id, carton_id).then(() => {
        updateOrderDeliveriedStatus(order.id, selectedSupplierId).then(data => {

        })
        reload();
        message.success({ content: `删除散箱成功`, key, duration: 2 });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const reload = (callback) => {
    getOrderPackageProgress(order.id).then(data => {
      setProcess(data);
      const temp = { percent: 0, orderGoodsCount: 0, orderGoodsOkCount: 0 };
      data.forEach(x => {
        x.order_goods_purchase_count && (temp.orderGoodsCount += x.order_goods_purchase_count);
        x.ok_real && (temp.orderGoodsOkCount += x.ok_real);
      });
      temp.percent = toFixed2(temp.orderGoodsOkCount * 100.0 / temp.orderGoodsCount, 1)
      setProgressInfo(temp);
      if (temp.percent > 99.9999) {
        const status = [].concat(tabStatus);
        status[2] = true;
        setTabStatus(status);
      }
    });
    getSupplierByOrderid(order.id).then(data => (setOrderSuppliers(data)));
    getOrderPackageList(order.id).then(pkgs => {
      const temp = pkgs.filter(x => x.package_status === 1);
      temp.forEach((x, i) => {
        x.weight = x.unit_weight * x.count * 0.001;
      });
      setPackages(temp);
      getOrderPackagePalletList(order.id).then(plts => {
        const temp = plts.filter(x => x.package_status === 1);
        setPallets(temp);
        callback && callback();
      })
    });
  }

  const onDeletePackageNo = () => {
    Modal.confirm({
      title: `确定删除当前箱单号吗?`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{`${packageNos.find(x => x.id === selectedPackageId).no}`}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        try {
          const key = 'new_package_no';
          console.log('onDeletePackageNo:');
          message.loading({ content: '正在删除箱单号...', key });
          deletePackageNo(order.id, selectedSupplierId, selectedPackageId).then(() => {
            reloadPackageNoList(() => { setSelectedPackageId(-1) });
            message.success({ content: `删除箱单号成功`, key, duration: 1 });
          })
        } catch (errInfo) {
          console.log('Error:', errInfo);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  const onNewPackageNo = () => {
    try {
      const key = 'new_package_no';
      console.log('onNewPackageNo:');
      message.loading({ content: '正在添加新箱单号...', key });
      insertPackageNo(order.id, selectedSupplierId).then(() => {
        reloadPackageNoList((data) => setSelectedPackageId(data[data.length - 1].id));
        message.success({ content: `添加新箱单号成功`, key, duration: 1 });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onNewPallet = () => {
    const values = { supplier_id: selectedSupplierId, package_id: selectedPackageId };
    try {
      const key = 'new_pallet';
      console.log('onNewPallet:', values);
      message.loading({ content: '正在添加新托盘...', key });
      insertSelfPackagePallet(order.id, values).then(() => {
        reload();
        message.success({ content: `添加新托盘成功`, key, duration: 2 });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const handleDeleteCarton = (carton) => {
    updateOrderPackageCartonState(carton.order_id, carton.package_id, carton.id, { ds: carton.ds, delete_flag: 1 }).then(data => {
      updatePackageNoListDeleteFlag(carton, true);
    })
  }

  const handleRestoreCarton = (carton) => {
    updateOrderPackageCartonState(carton.order_id, carton.package_id, carton.id, { ds: carton.ds, delete_flag: 0 }).then(data => {
      updatePackageNoListDeleteFlag(carton, false);
    })
  }

  const onPalletRecive = (value, id, is_self) => {
    try {
      const key = 'recive_pallet';
      console.log('onGoodsRecive:', id);
      message.loading({ content: '正在更新到货状态...', key });
      updatePalletReviceStatus(order.id, id, {
        target: is_self ? 'self' : 'supplier',
        recive_status: value
      }).then(() => {
        pallets.find(x => x.id === id).recive_status = value;
        setPallets([].concat(pallets))
        message.success({ content: `更新到货状态成功`, key, duration: 2 });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onCartonRecive = (value, id, is_self) => {
    try {
      const key = 'recive_carton';
      console.log('onCartonRecive:', id);
      message.loading({ content: '正在更新到货状态...', key });
      updateCartonReviceStatus(order.id, id, {
        recive_status: value,
        target: is_self === 1 ? 'self' : 'supplier'
      }).then(() => {
        packages.find(x => x.id === id).recive_status = value;
        setPackages([].concat(packages))
        message.success({ content: `更新到货状态成功`, key, duration: 2 });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const onDeletePallet = (id) => {
    try {
      const key = 'delete_pallet';
      console.log('onDeletePallet:', id);
      message.loading({ content: '正在删除托盘...', key });
      deleteSelfPackagePallet(order.id, id).then(() => {
        updateOrderDeliveriedStatus(order.id, selectedSupplierId).then(data => {

        })
        reload();
        message.success({ content: `删除托盘成功`, key, duration: 2 });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const total = {
    weight: 0,
    count: 0,
    amount: 0
  }
  filteredPackages.forEach((item, index) => {
    total.weight += (item.weight || 0);
    total.count += (item.carton_count * item.count_per_carton);
    total.amount += 0;
  });

  const cartons = filteredPackages.filter(x => x.pallet_id === -1);
  let total_cartons_weights = 0;
  let total_cartons_count = 0;
  cartons.forEach((item, index) => {
    total_cartons_weights += (item.weight || 0);
    total_cartons_count += (item.carton_count || 0);
  });

  const io = (
    <Menu>
      <Menu.Item onClick={onNewPackageNo} key="0" icon={<PlusOutlined />}>
        新建箱单号
      </Menu.Item>
      <Menu.Divider></Menu.Divider>
      <Menu.Item disabled={!selectedPackageNo || selectedPackageNo.ds === 0} onClick={onNewPallet} key="1" icon={<PlusOutlined />}>
        新建托盘
      </Menu.Item>
      <Menu.Item disabled={!selectedPackageNo || selectedPackageNo.ds === 0} onClick={() => addNew(-1, -1)} key="2" icon={<PlusOutlined />}>
        新建散箱
      </Menu.Item>
    </Menu>
  );

  const addNew = (index, id) => {
    setCurrentPalletId(id);
    setShowCartonNew(true);
  }

  const showConfirmDeleteCarton = (carton) => {
    Modal.confirm({
      title: `确定删除当前项目吗?`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{`${carton.goods_name} ${carton.goods_spec_name} ${carton.count}件`}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        if (onDeleteCarton) {
          onDeleteCarton(carton.id);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const returnPackage = () => {
    Modal.confirm({
      title: `该箱单号所有装箱信息会全部退回供应商?`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{selectedPackageNo.no}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        const key = 'return_package_no';
        console.log('returnPackage:');
        message.loading({ content: '正在退回箱单号...', key });
        returnOrderPackageNo(order.id, selectedPackageId).then(() => {
          updateOrderDeliveriedStatus(order.id, selectedSupplierId).then(data => {

          })
          reload();
          reloadPackageNoList(() => { setSelectedPackageId(-1) });
          message.success({ content: `退回箱单号成功`, key, duration: 2 });
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onChangePalletRecive = (value, pallet_id, is_self) => {
    onPalletRecive(value, pallet_id, is_self);
  }

  const onChangeCartonRecive = (value, pallet_id, is_self) => {
    onCartonRecive(value, pallet_id, is_self);
  }
  const deletePallet = (index, pallet_id) => {
    Modal.confirm({
      title: `确定删除当前项目吗?`,
      icon: <ExclamationCircleOutlined />,
      content: <strong>{`第${index}托盘`}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        if (onDeletePallet) {
          onDeletePallet(pallet_id);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  return (
    <div id="container">
      <div style={{ fontSize: '1.25rem', backgroundColor: 'bisque', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 1rem', margin: '0 0 0rem 0' }}>
        <div>
          <strong>当前发货进度({progressInfo.percent}%)：[ {progressInfo.orderGoodsOkCount}/{progressInfo.orderGoodsCount}件 ]
            <Button size="large" onClick={() => setShowProgress(true)} type="link">查看明细</Button></strong>
          <Button onClick={() => setShowSync(true)} style={{ marginLeft: '2rem' }} icon={<ReloadOutlined />}>同步供应商数据</Button>
        </div>
        <div>
          <Countdown value={order.delivery_deadline_date} format="剩余：D 天 H 时 m 分 s 秒" />
        </div>
      </div>
      <Affix target={() => container}>
        <div style={{ backgroundColor: 'rgb(220, 222, 245)', display: 'flex', alignItems: 'center', padding: '1rem' }}>
          <Select
            placeholder="请选择供应商进行过滤"
            onChange={onChangeSupplier}
            defaultValue={selectedSupplierId}
            style={{ width: '45rem', marginRight: '0.5rem' }}
          >
            <Select.Option key={-1} value={-1}>
              --全部供应商--
            </Select.Option>
            {
              orderSuppliers.map(x =>
                <Select.Option key={x.id} value={x.id}>
                  {x.name}
                </Select.Option>
              )
            }
          </Select>
          <Select
            disabled={selectedSupplierId < 0}
            placeholder="请选择箱单号进行过滤"
            onChange={setSelectedPackageId}
            value={selectedPackageId}
            style={{ width: '50rem', marginRight: '0.5rem' }}
          >
            <Select.Option key={-1} value={-1}>
              --全部箱单号--
            </Select.Option>
            {
              packageNos.map(x =>
                <Select.Option disabled={x.status === 0 || x.status === 2} key={x.id} value={x.id}>
                  {order.po}-{x.no} {x.status === 0 && '未同步'}{x.status === 2 && '已退回'}
                </Select.Option>
              )
            }
          </Select>
          <Dropdown.Button style={{ marginRight: '1rem' }} disabled={selectedSupplierId === -1} overlay={io} icon={<PlusOutlined />} >代填</Dropdown.Button>
          <Button disabled={!selectedPackageNo || selectedPackageNo.ds === 1 || selectedPackageNo.status !== 1 || packages.filter(x => x.package_id === selectedPackageId && x.plan_id).length > 0} type="primary" onClick={() => returnPackage(selectedPackageId)} icon={<IssuesCloseOutlined />} >退回供应商</Button>
          <Button disabled={!selectedPackageNo} type="link" size="small" onClick={() => downloadPackagePost(order, selectedPackageNo, suppliers.find(x => x.id === selectedSupplierId), filteredPackages)}>下载此装箱单</Button>
          <Button disabled={!selectedPackageNo} type="link" size="small" onClick={() => downloadPalletDetail(order, selectedPackageNo)}>下载托盘明细</Button>
        </div>
      </Affix>
      <div style={{ padding: '0 1rem' }}>
        {
          (filteredPackages.length === 0 && filteredPallets.length === 0) && <div style={{ minHeight: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div>
              <p>当前暂无供应商发货，请点击"同步供应商数据"或者联系相应供应商进行确认。</p>
              <p>当供应商没有在线填写条件情况下、可以选择代填。</p>
              {
                (selectedSupplierId > 0 && selectedPackageId > 0) && <p><Button type="primary" onClick={onNewPallet}>添加托盘</Button>&nbsp;&nbsp;
                  <Button onClick={() => addNew(-1, -1)}>添加散箱</Button>&nbsp;&nbsp;&nbsp;&nbsp;
                  <Button danger onClick={onDeletePackageNo}>删除此箱单号</Button></p>
              }
              {
                (selectedSupplierId > 0 && selectedPackageId < 0) && <p>
                  <Button danger onClick={onNewPackageNo}>添加箱单号</Button></p>
              }
            </div>
          </div>
        }
        {
          (filteredPackages.length > 0 || filteredPallets.length > 0) &&
          <table style={{ border: '2px solid #f0f0f0' }} className="table" border="2">
            <thead style={{ backgroundColor: '#f0f0f0' }}>
              <tr>
                <th className="th" rowSpan="2" width="65px"><Checkbox /></th>
                <th className="th" rowSpan="2" width="385px">产品号</th>
                {isShowSupplier && <th className="th" rowSpan="2" width="180px">供应商</th>}
                {isShowDeliveryDate && <th className="th" rowSpan="2" width="120px" >箱单号</th>}
                <th className="th" rowSpan="2" width="120px" >发货日期</th>
                <th className="th" rowspan="2" width="100px">箱数</th>
                <th className="th2" colspan="2" width="200px">数量(件)</th>
                <th className="th2" rowSpan="2" width="100px">重量<br />(千克)</th>
                <th className="th2" rowSpan="2" width="100px">总重量<br />(千克)</th>
                <th className="th2" rowSpan="2" width="140px">发票号</th>
              </tr>
              <tr>
                <th align="center" className="th2" width="100">件数/箱</th>
                <th align="center" className="th2" width="100">总件数</th>
              </tr>
            </thead>
            <tbody>
              {
                filteredPallets.map((item, pindex) => {
                  const palletPackage = filteredPackages.filter(x => x.pallet_id === item.id);
                  let total_weights = 0;
                  let total_cartons = 0;
                  for (let i = 0; i < palletPackage.length; i++) {
                    total_weights += (palletPackage[i].weight || 0);
                    total_cartons += (palletPackage[i].carton_count || 0);
                  }
                  return [
                    <tr>
                      <td style={{ backgroundColor: '#f0f0f0' }} className="td" colspan={10}>
                        <div style={{ fontSize: "1.1rem", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <strong>
                            第{pindex + 1}托盘 {chkPallet(palletPackage, true).content} &nbsp;&nbsp;<Switch checked={item.recive_status} onChange={(value) => onChangePalletRecive(value, item.id, item.ds === 1)} />&nbsp;已到货
                          </strong>
                          {(item.ds === 1) && <div>
                            <Button disabled={palletPackage.filter(pp => pp.plan_id).length > 0 || selectedSupplierId < 0 || selectedPackageId < 0} size="small" onClick={() => deletePallet(pindex + 1, item.id)} danger icon={<DeleteOutlined />} >删除此托盘</Button>
                            <Button disabled={selectedSupplierId < 0 || selectedPackageId < 0} size="small" onClick={() => addNew(pindex, item.id)} type="primary" style={{ marginLeft: '1rem' }} icon={<PlusOutlined />} >往此托盘添加散箱</Button>
                          </div>}
                        </div>
                      </td>
                    </tr>,
                    palletPackage.map((carton, index) => {
                      return <tr className={carton.delete_flag ? 'delete-row' : ''}>
                        {
                          index === 0 && <td className="td" align="center" rowspan={palletPackage.length}><Checkbox /></td>
                        }
                        <td className="td">
                          {carton.goods_name} {carton.goods_spec_name} {carton.size}
                          {carton.ds === 1 && <span style={{ color: 'blue' }}>[代填]
                            {!carton.plan_id && <Button type="link" onClick={() => showConfirmDeleteCarton(carton)} danger size="small" icon={<DeleteOutlined />}></Button>}
                          </span>}
                        </td>
                        {isShowSupplier && <td className="td" >{carton.supplier_name}</td>}
                        {isShowDeliveryDate && <td className="td" align="center" >{carton.package_no}</td>}
                        <td className="td" align="center" >{carton.package_delivery_date}</td>
                        <td align="right" className="td">{toThousands(carton.carton_count)}</td>
                        <td align="right" className="td">{toThousands(carton.count_per_carton)}</td>
                        <td align="right" className="td">{toThousands(carton.carton_count * carton.count_per_carton)}</td>
                        <td align="right" className="td">{toThousands(carton.weight.toFixed(2))}</td>
                        {
                          index === 0 && <td align="right" className="td" rowspan={palletPackage.length}>{toThousands(total_weights.toFixed(2))}</td>
                        }
                        <td align="center" className="td">
                          {(!carton.plan_id && !carton.delivery_no && !carton.delete_flag) && <Button onClick={() => handleDeleteCarton(carton)} danger type='text' size='small'>临时删除</Button>}
                          {(!carton.plan_id && !carton.delivery_no && carton.delete_flag) && <Button onClick={() => handleRestoreCarton(carton)} type='link' size='small'>解除删除</Button>}
                          {carton.plan_id && <span style={{ color: 'green' }}>[{carton.delivery_no}]</span>}
                        </td>
                      </tr>
                    })
                  ]
                })
              }
              <tr>
                <td style={{ backgroundColor: '#f0f0f0' }} className="td" colspan="10">
                  <div style={{ fontSize: "1.1rem", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <strong>散箱</strong>
                    <Button size="small" onClick={() => addNew(-1, -1)} disabled={selectedSupplierId < 0 || !selectedPackageNo || selectedPackageNo.ds === 0} type="primary" style={{ marginLeft: '1rem' }} icon={<PlusOutlined />} >添加散箱</Button>
                  </div>
                </td>
              </tr>
              {
                cartons.map((item, index) => {
                  return <tr>
                    <td className="td" align="center"><Checkbox /></td>
                    <td className="td">{item.goods_name} {item.goods_spec_name} {item.size} {item.ds === 1 && <span style={{ color: 'blue' }}>[代填]
                      {!item.plan_id && <Button type="link" onClick={() => showConfirmDeleteCarton(item)} danger size="small" icon={<DeleteOutlined />}></Button>}</span>}&nbsp;<Switch checked={item.recive_status} onChange={(value) => onChangeCartonRecive(value, item.id, item.ds === 1)} />&nbsp;已到货</td>
                    {isShowSupplier && <td className="td" >{item.supplier_name}</td>}
                    {isShowDeliveryDate && <td className="td" align="center" >{item.package_no}</td>}
                    <td className="td" align="center" >{item.package_delivery_date}</td>
                    <td align="right" className="td">{toThousands(item.carton_count)}</td>
                    <td align="right" className="td">{toThousands(item.count_per_carton)}</td>
                    <td align="right" className="td">{toThousands(item.carton_count * item.count_per_carton)}</td>
                    <td align="right" className="td">{toThousands(item.weight.toFixed(2))}</td>
                    {
                      index === 0 && <td align="right" className="td" rowspan={filteredPackages.filter(x => x.pallet_id === item.id).length}>
                        {
                          toThousands(total_cartons_weights.toFixed(2))
                        }
                      </td>
                    }
                    <td align="center" className="td">{item.plan_id && <span style={{ color: 'green' }}>[{item.delivery_no}]</span>} </td>
                  </tr>
                })
              }
            </tbody>
            <tfoot style={{ backgroundColor: '#f0f0f0' }}>
              <td className="td" colSpan={3 + (isShowSupplier && 1) + (isShowDeliveryDate && 1)}>
                <div style={{ fontSize: '1.1rem' }}>
                  <strong>合计：    {filteredPallets.length}托   +  {total_cartons_count}散箱</strong>
                </div>
              </td>
              <td className="td" colSpan="2">
                <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
                  <strong>总数量:  {toThousands(total.count)}</strong>
                </div>
              </td>
              <td className="td" colSpan="2">
                <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
                  <strong>总重量:  {toThousands(total.weight.toFixed(2))}</strong>
                </div>
              </td>
              <td className="td">
              </td>
            </tfoot>
          </table>
        }

        <Divider style={{ margin: '0' }} />
        <div className="page-footer">
          <div></div>
          <Space size="large">
            {onClose && <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>}
          </Space>
        </div>
      </div>
      <Page
        title="装箱单代填"
        width="480px"
        onCloseCallback={() => setShowCartonNew(false)}
        body={<CartonNew
          filteredPallets={filteredPallets}
          progress={progress}
          carton={{ supplier_id: selectedSupplierId, order_id: order.id, package_id: selectedPackageId, currentPalletId: currentPalletId }}
          onSaveCallback={onAddNewPackage}
          onCloseCallback={() => setShowCartonNew(false)} />}
        visible={isShowCartonNew} />
      <Page
        title="发货进度明细"
        isMaximize={true}
        onCloseCallback={() => setShowProgress(false)}
        body={<PackageDetail
          suppliers={orderSuppliers}
          rows={progress}
          onCloseCallback={() => setShowProgress(false)} />}
        visible={isShowProgress} />
      <Page
        title="待同步装箱单明细"
        isMaximize={true}
        onCloseCallback={() => setShowSync(false)}
        body={<SyncList
          suppliers={suppliers}
          order={order}
          reload={() => { reload(); reloadPackageNoList(); }}
          orderId={order.id}
          onCloseCallback={() => setShowSync(false)} />}
        visible={isShowSync} />
    </div >
  );
});